<template>
  <div class="centerdiv">
    <h2>公告管理</h2>
    <el-row>
      <el-col :span=12>
        <el-row>
          <el-col :span="9" class='labright'>发布新公告</el-col>
          <el-col :span="6" class='textleft'>
            <el-input v-model="noticeText"></el-input>
          </el-col>
          <el-col :span="9" class='textleft'>
           <el-button type="primary" @click="add_new_notice" style="width:150px">发布</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { addNewNotice } from '@/api/api_notice.js'

  export default {
    data () {
      return {
        startMain: 0
      }
    },
    computed: {
      ...mapGetters([
        'welcome'
      ])
    },
    created () {

    },
    mounted () {

    },
    methods: {
      showMsg (msg, type = 'warning') {
        this.$notify({
          title: '出题',
          message: msg,
          type: type
        })
      },
      commit () {

      },
      add_new_notice () {
        let sm = {}
        sm.notice = this.noticeText
        addNewNotice(sm).then((res) => {
          if (res.data) {
            if (res.data.isOk === true) {
              this.showMsg('公告已发布。', 'info')
            } else {
              this.showMsg('公告发布失败。', 'info')
            }
          } else {
            this.showMsg('公告发布不成功。', 'info')
          }
        }).catch(err => {
          this.showMsg(`公告发布失败2。${err}`)
        })
      }
    }
  }
</script>

<style scoped>
  .centerdiv {
    height: auto;
    text-align: center;
  }

  .labright {
    height: 50px;
    line-height: 40px;
    text-align: right;
    vertical-align: middle;
  }
  .rowheight{
    text-align: right;
    vertical-align: middle;
  }
  .textleft {
    text-align: left;
    height: 30px;
  }

  .lableft {
    text-align: left;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// noticePage.vue?1094f59e